import { Component, OnInit,Inject, ViewEncapsulation, ElementRef } from '@angular/core';
import { Validators,FormBuilder,FormGroup, FormControl, FormArray } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { Router,ActivatedRoute } from '@angular/router';
import {
    DynamicFormService,
    DynamicFormControlModel,
    DynamicFormArrayModel,
    DynamicInputModel,
    DynamicCheckboxModel,
    DynamicCheckboxGroupModel,
    DynamicRadioGroupModel,
    DynamicSelectModel,
    DynamicTextAreaModel,
    DynamicFormGroupModel
} from '@ng2-dynamic-forms/core';
import { customValidator } from '../app.validators';
import { PartnerQuestionsService } from '../../../_services/partner-questions.service';
import { AuthenticationService } from '../../../_services/index';
import {MatDialog} from '@angular/material';
import {ConfirmationDialogComponent} from '../confirmation-dialog/confirmation-dialog.component';
import { FormDoneService } from '../../../_services/form-done.service';
import { DialogPdfComponent } from '../dialog-pdf/dialog.component';
import { PageScrollService, PageScrollInstance } from 'ngx-page-scroll';
import { DOCUMENT } from '@angular/common';

declare var $:any;

@Component({
  selector: 'app-partner-questions',
  templateUrl: './partner-questions.component.html',
  styleUrls: ['./partner-questions.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [PartnerQuestionsService, AuthenticationService]
})
export class PartnerQuestionsComponent implements OnInit {

  digitalForm: FormGroup;
  digitalFormSub: Subscription;
  formModel: DynamicFormControlModel[];
  formGroup: FormGroup;
  questions = [];
  getquestions;
  getanswers;
  formcheck = false;
  public valueChange = false;
  public canDeactivateCheck = false;
  public checkingSubmit = false;
  showCalSarUploadTag =false;
  partnerid;
  error: boolean;
  errorFlag: boolean;
  successMessage: string;
  errorMessage: string;
  errorFlag1: boolean;
  successMessage1: string;
  errorMessage1: string;
  submitBtnText = '';
  submitting: boolean;
  fieldErrors: any;
  loading: boolean;
  submitdataSub: Subscription;
  digital_formats;
  partnername;
  lastInserted;
  finalSubmit;
  recommendtionFileget;
  digitalsignFileget;
  recommendtionFiletext;
  digitalsignFiletext;
  recommendtionFilein = false;
  digitalsignFilein = false;
  recommendtionFileid;
  digitalsignFileid;
  eData;
  today;
  adult = true;
  todaydate = '';
  required =  true;
  disableApply = false;
  disableSubmit = true;
  isCNIC=false;
  recommendtion_link;
  digitalsign_link;
  pdfSrc;

  constructor(private _fb: FormBuilder,private formService: DynamicFormService,
      private formapi: PartnerQuestionsService,
      private router: Router,
      private loginservice: AuthenticationService,
      public dialog: MatDialog,
      private api: FormDoneService,
      private elRef:ElementRef,
      private pageScrollService: PageScrollService,
      @Inject(DOCUMENT) private document: any,


  ) {
      this.getQuestionsData();
      
  }

  buildForm() {
    console.log(this.questions);
    this.questions = [];
    console.log(this.questions);
    for (const question of this.getquestions) {
      if (question.type === 'textbox')  {
        const qid = question.id;
        let value = '';
        if (question['value'] !== '') {
            value = question['value'];
        }
        if (this.getanswers && this.getanswers[qid])  {
          value = this.getanswers[qid];
        }
        this.questions.push(
          new DynamicInputModel({
            id: qid,
            label: question.question,
            value: value,
            required: question.required
          },
          {
            element: {
                container: 'form-group',
                label: 'control-label'
            },
            grid: {
                control: 'col-sm-9',
                label: 'col-sm-3'
            }
          })
        );
      } else if (question.type === 'file')  {
        const qid = question.id;
        //console.log(qid);
        
        if (qid == "recommendation") {
          
          this.recommendtionFilein = true;
          this.recommendtionFiletext = question.question;
  
        }

        if (qid == "digitalsign") {
        
          this.digitalsignFilein = true;
          this.digitalsignFiletext = question.question;
        }

        /* console.log(this.recommendtionFilein);
        console.log(this.recommendtionFiletext); */

        if(this.recommendtionFilein){
          let split = this.recommendtionFiletext.split("<a");
          if(split[0]){
            this.recommendtionFiletext = split[0];
          }
          this.recommendtionFiletext = this.recommendtionFiletext.replace(/<\/?[^>]+(>|$)/g, "");
        }
        
        /* console.log(this.recommendtionFiletext);

        console.log(this.digitalsignFilein); */
        if(this.digitalsignFilein){
          let split1 = this.digitalsignFiletext.split("<a");
          if(split1[0]){
            this.digitalsignFiletext = split1[0];
          }
          this.digitalsignFiletext = this.digitalsignFiletext.replace(/<\/?[^>]+(>|$)/g, "");

        }
        //console.log(this.digitalsignFiletext);

        this.questions.push(
          new DynamicInputModel({
            id: qid,
            inputType: 'file',
            label: question.question,
            // value: value,
            // required: question.required
          },
          {
            element: {
                container: 'form-group form-box border-btm',
                label: 'control-label'
            },
            grid: {
                control: 'col-sm-9',
                label: 'col-sm-3'
            }
          })
        );
      } else if (question.type === 'textarea') {
        const qid = question.id;

        let value;
        if (this.getanswers && this.getanswers[qid])  {
          value = this.getanswers[qid];

        }
        this.questions.push(
          new DynamicTextAreaModel({
            id: qid,
            label: question.question,
            rows: 5,
            value: value
          },
          {
            element: {
                container: 'form-group form-box border-btm txtarea',
                label: 'control-label'
            },
            grid: {
                control: 'col-sm-9',
                label: 'col-sm-3'
            }
          })
        );

      } else if (question.type === 'checkbox') {
        const qid = question.id;
        const options = question.options;
        const check = [];

        for (const option of options) {
          let valueCheck;
          if (this.getanswers && this.getanswers[qid][option.id]) {
              valueCheck = this.getanswers[qid][option.id];
          }

          check.push(
            new DynamicCheckboxModel(
              {
                id: option.id,
                label: option.label,
                value: valueCheck
              }
            )
          );
        }
        this.questions.push(
          new DynamicCheckboxGroupModel({
            id: qid,
            legend: question.question,
            group: check,
          },
          {
            element: {
              container: 'form-group form-box border-btm dynamic-checkbox',
              label: 'control-label'
            },
            grid: {
              control: 'col-sm-9 dynamic-checkbox-control',
              label: 'col-sm-3 dynamic-checkbox-label'
            }
          })
        );
      } else if (question.type === 'radio') {
        const qid = question.id;
        const options = question.options;
        const radio = [];
        for (const option of options) {
          radio.push({
            label: option.label,
            value: option.value
          });
        }
        let value;
        if (this.getanswers && this.getanswers[qid]) {
          value = this.getanswers[qid];
        }
        this.questions.push(
          new DynamicRadioGroupModel<string>({
            id: qid,
            legend: question.question,
            options: radio,
            value: value
          },
          {
            element: {
              container: 'form-group form-box border-btm dynamic-radio',
              label: 'control-label'
            },
            grid: {
              control: 'col-sm-9 dynamic-radio-control',
              label: 'col-sm-3 dynamic-radio-label'
            }
          })
        );
      }
    }
    this.formModel = this.questions;
    this.formGroup = this.formService.createFormGroup(this.formModel);
  }

  ngOnInit() {
    let today:any;
    today = new Date();
    let dd:any;
    let mm:any;
    dd = today.getDate();
    mm = today.getMonth()+1; //January is 0!
    let yyyy = today.getFullYear();

    if(dd<10) {
        dd = '0'+dd
    } 

    if(mm<10) {
        mm = '0'+mm
    } 

    this.today = mm + '/' + dd + '/' + yyyy;
    //console.log(this.today);
    
    this.createForm();
    this.checkCinc();
  }

  ngAfterViewInit(){    

    /* setTimeout(function(){ 
          var id ="";
          $('input[name=text], textarea').each(
          function(index){                
            id = $(this).prop('id');
            console.log($('#edit_'+ id).length);
            if($('#edit_'+ id).length == 0) {
              //object already exists
              $("#"+id).Editor();
              $("#"+id).next(".Editor-container").prop("id", 'edit_'+ id);
              $("#"+id).next(".Editor-container").data("txtAreaid",  id);
              $("#"+id).next(".Editor-container").find(".Editor-editor").html( $(this).val() );
            }
          }
      );        
      }, 3000); */
    
  }

  replaceTxtAreaVal()
  {
    var txtAreaid;    
    var inc =0;

    $('input[name=text], textarea').each(
      function(index){  
        txtAreaid = $(this).prop("id");
        $("#"+txtAreaid).val( $("#"+txtAreaid).Editor("getText") );                   
      }
    );
  }

  getQuestionsData() {
    this.loading = true;
    const getDomainName = this.loginservice.getDomainName();
    const parts = window.location.hostname.split(getDomainName);
    console.log(parts);
    const countLength = parts.length;
    const subdomain = parts.shift();
    console.log(subdomain);
    if (countLength === 2) {
      this.formapi.getQuestionsData$(subdomain).subscribe(
        responsedata => {
          const headerData = responsedata.data;
          this.getquestions = headerData.form_data;
          if(this.getquestions.length == 0){
            this.router.navigate(['/user-dashboard']);
          }
          this.partnerid = headerData.partner_id;
          this.partnername = headerData.partner_name;
          this.digital_formats = headerData.digital_formats;
          this.loading = false;
          this.getStudnetAnswer();

        },
        error => {
            console.log(error);
        },
      );
    }
    else{
      if(subdomain == 'localhost'){
        this.formapi.getQuestionsData$('onefuturecv').subscribe(
          responsedata => {
            const headerData = responsedata.data;
            this.getquestions = headerData.form_data;
            if(this.getquestions.length == 0){
              this.router.navigate(['/user-dashboard']);
            }
            this.partnerid = headerData.partner_id;
            this.partnername = headerData.partner_name;
            this.digital_formats = headerData.digital_formats;
            this.loading = false;
            this.getStudnetAnswer();
  
          },
          error => {
              console.log(error);
          },
        );
      }
    }
  }

  ngonChange(){

  }

  onSubmit() {
    //console.log($("#yourintend2").Editor("getText"));
    var txtAreaid; 
    let formGroup = this.formGroup;
    $('input[name=text], textarea').each(
      function(index){  
        txtAreaid = $(this).prop("id");
        formGroup.controls[txtAreaid].setValue( $("#"+txtAreaid).Editor("getText") );
      }
    );
    //console.log(formGroup);
    this.formGroup = formGroup;
    //console.log(this.formGroup);   
    this.loading = true;
    let digitalsignfile;
    let recommendationfile;
    this.formModel.forEach((data) => {
      const model = data;
      if (model.id === 'recommendation') {
        if (model['files'] === null) {

        } else {
          recommendationfile = model['files'][0];
        }
      } else if (model.id === 'digitalsign') {
        if (model['files'] === null) {

        } else {
          digitalsignfile = model['files'][0];
        }
      }
    });

    const allowedMIMEType = ['application/pdf'];

    if(this.recommendtionFilein){
      if( typeof recommendationfile == 'undefined')
      {
  
        /* if(this.recommendtionFileget == null){
          this.loading = false;
          this.submitting = false;
          this.errorFlag = true;
          this.errorMessage = this.recommendtionFiletext+' is required';
          window.scrollTo(300, 500);
          return false;
        } */
        
      }
      else {
        let ext1 = '';
        const mimeType1 = recommendationfile.type;
        ext1 = recommendationfile.name.split('.').pop();
        if (allowedMIMEType.indexOf(mimeType1) >= 0 ) {
        }
        else{
          this.errorMessage = 'Only pdf file is allowed';
          this.errorFlag = true;
          this.loading = false;
          window.scrollTo(300, 500);
          return false;
        }
      }

    }

    if(this.digitalsignFilein) {

      if( typeof digitalsignfile == 'undefined')
      {
        /* if(this.digitalsignFileget == null){
          this.loading = false;
          this.submitting = false;
          this.errorFlag = true;
          this.errorMessage = this.digitalsignFiletext+' is required';
          window.scrollTo(300, 500);
          return false;
        } */

      } else {

        let ext2 = '';
        const mimeType2 = digitalsignfile.type;
        ext2 = digitalsignfile.name.split('.').pop();
        if (allowedMIMEType.indexOf(mimeType2) >= 0 ) {
        }
        else{
          this.errorMessage = 'Only pdf file is allowed';
          this.errorFlag = true;
          this.loading = false;
          window.scrollTo(300, 500);
          return false;
        }
        
      }
      
    }
    
    if (!this.isEmpty(this.formGroup.value)) {
        
        const body1 = {
          partnerid: this.partnerid,
          //lastInserted: this.lastInserted,
          formdata:JSON.stringify(this.formGroup.value),
          isCNIC:this.isCNIC
      
        };
       
        const body2 = {
          recommendationfile: recommendationfile,
          digitalsignfile:digitalsignfile,
          recommendtionFileid:this.recommendtionFileid,
          digitalsignFileid:this.digitalsignFileid
        };
        this.submitting = true;
        this.formapi.postFormData$(body1, body2)
        .subscribe(
          data => {
            this.error = false;
            this.submitting = false;
            this.errorFlag = false;
            const response = JSON.parse(data._body);
            this.successMessage = response.message;
            this.loading = false;
            if (!this.canDeactivateCheck) {
              this.checkingSubmit = true;
              window.scrollTo(300, 500);
              this.finalSubmit = true;
              this.getStudnetAnswer()

            }
          },
          error => {
            this.submitting = false;
            this.errorFlag = true;
            const errordata = JSON.parse(error._body);
            if (errordata.success === 0) {
              this.errorMessage = errordata.message;
              this.errorFlag = true;
              this.fieldErrors = errordata.errors;
              this.loading = false;
              window.scrollTo(300, 500);
              if( errordata.calsarErrorCode == 1) {
                this.showCalSarUploadTag=true;
              }
            }
            
          },
        );
    } else {
      this.router.navigate(['/user-dashboard']);
    }

  }

  getStudnetAnswer() {
    this.loading = true;
    const body = JSON.stringify({
      partnerid: this.partnerid,
    });
    this.formapi.getStudnetAnswer$(body).subscribe(
      responsedata => {
        const headerData = responsedata.data;
        this.getanswers = JSON.parse(headerData.form_data);

        this.recommendtionFileget = headerData.Recommendtion;
        this.digitalsignFileget = headerData.Digitalsign;
        this.recommendtion_link = headerData.Recommendtion_link;
        this.digitalsign_link = headerData.Digitalsign_link;
        //console.log(this.recommendtionFileget);
        //console.log(this.digitalsignFileget);

        this.recommendtionFileid = headerData.Recommendtionid;
        this.digitalsignFileid = headerData.Digitalsignid;
        this.formcheck = true;
        this.buildForm();
        //console.log(headerData.form_data);
        //console.log(this.getanswers);
        if(this.getanswers){
          this.finalSubmit = true;
        }

        setTimeout(function(){ 
          var id ="";
          $('input[name=text], textarea').each(
            function(index){                
              id = $(this).prop('id');
              if($('#edit_'+ id).length == 0) {
                //object already exists
                $("#"+id).Editor();
                $("#"+id).next(".Editor-container").prop("id", 'edit_'+ id);
                $("#"+id).next(".Editor-container").data("txtAreaid",  id);
                $("#"+id).next(".Editor-container").find(".Editor-editor").html( $(this).val() );
              }
              
            }
          );        
        }, 0);
        this.loading = false;
        const pageScrollInstance: PageScrollInstance = PageScrollInstance.simpleInstance(this.document, '.contSectionBox');
        this.pageScrollService.start(pageScrollInstance);
      },
      error => {
        console.log(error);
      },
    );
  }

  openDialog() {

    /* if(this.recommendtionFilein){

       if(this.recommendtionFileget == null){
          this.loading = false;
          this.submitting = false;
          this.errorFlag = true;
          this.errorMessage = this.recommendtionFiletext+' is required';
          window.scrollTo(300, 500);
          return false;
        
      }

    }

    if(this.digitalsignFilein) {

      if(this.digitalsignFileget == null){
          this.loading = false;
          this.submitting = false;
          this.errorFlag = true;
          this.errorMessage = this.digitalsignFiletext+' is required';
          window.scrollTo(300, 500);
          return false;
      }
      
    } */

    //console.log($("#yourintend2").Editor("getText"));
    var txtAreaid; 
    let formGroup = this.formGroup;
    $('input[name=text], textarea').each(
      function(index){  
        txtAreaid = $(this).prop("id");
        formGroup.controls[txtAreaid].setValue( $("#"+txtAreaid).Editor("getText") );
      }
    );
    //console.log(formGroup);
    this.formGroup = formGroup;
    //console.log(this.formGroup);   
    this.loading = true;
    let digitalsignfile;
    let recommendationfile;
    this.formModel.forEach((data) => {
      const model = data;
      if (model.id === 'recommendation') {
        if (model['files'] === null) {

        } else {
          recommendationfile = model['files'][0];
        }
      } else if (model.id === 'digitalsign') {
        if (model['files'] === null) {

        } else {
          digitalsignfile = model['files'][0];
        }
      }
    });

    const allowedMIMEType = ['application/pdf'];

    if(this.recommendtionFilein){
      if( typeof recommendationfile == 'undefined')
      {
  
        if(this.recommendtionFileget == null){
          this.loading = false;
          this.submitting = false;
          this.errorFlag = true;
          this.errorMessage = this.recommendtionFiletext+' is required';
          window.scrollTo(300, 500);
          return false;
        }
        
      }
      else {
        let ext1 = '';
        const mimeType1 = recommendationfile.type;
        ext1 = recommendationfile.name.split('.').pop();
        if (allowedMIMEType.indexOf(mimeType1) >= 0 ) {
        }
        else{
          this.errorMessage = 'Only pdf file is allowed';
          this.errorFlag = true;
          this.loading = false;
          window.scrollTo(300, 500);
          return false;
        }
      }

    }

    if(this.digitalsignFilein) {

      if( typeof digitalsignfile == 'undefined')
      {
        if(this.digitalsignFileget == null){
          this.loading = false;
          this.submitting = false;
          this.errorFlag = true;
          this.errorMessage = this.digitalsignFiletext+' is required';
          window.scrollTo(300, 500);
          return false;
        }

      } else {

        let ext2 = '';
        const mimeType2 = digitalsignfile.type;
        ext2 = digitalsignfile.name.split('.').pop();
        if (allowedMIMEType.indexOf(mimeType2) >= 0 ) {
        }
        else{
          this.errorMessage = 'Only pdf file is allowed';
          this.errorFlag = true;
          this.loading = false;
          window.scrollTo(300, 500);
          return false;
        }
        
      }
      
    }
    
    if (!this.isEmpty(this.formGroup.value)) {
        
        const body1 = {
          partnerid: this.partnerid,
          //lastInserted: this.lastInserted,
          formdata:JSON.stringify(this.formGroup.value),
          isCNIC:this.isCNIC
      
        };
       
        const body2 = {
          recommendationfile: recommendationfile,
          digitalsignfile:digitalsignfile,
          recommendtionFileid:this.recommendtionFileid,
          digitalsignFileid:this.digitalsignFileid
        };
        this.submitting = true;
        this.formapi.postFormData$(body1, body2)
        .subscribe(
          data => {
            this.error = false;
            this.submitting = false;
            this.errorFlag = false;
            const response = JSON.parse(data._body);
            this.successMessage = response.message;
            this.loading = false;
            if (!this.canDeactivateCheck) {
              this.checkingSubmit = true;
              window.scrollTo(300, 500);
              this.finalSubmit = true;
              this.getStudnetAnswer()
              this.replaceTxtAreaVal();    
              this.api.getFormData$()
                    .subscribe(responsedata => {
                      const formdata = responsedata.data;
                      //console.log(formdata);
                      const personalinformation = formdata.personalinformation;
                      const academicinformation = formdata.academicinformation;
                      const backgroundinformation = formdata.backgroundinformation;
                      const priorhighereducation = formdata.priorhighereducation;
                      const futurecollegeplans = formdata.futurecollegeplans;
                      const academiccareergoals = formdata.academiccareergoals;
                      const extracurrucaullar = formdata.extracurrucaullar;
                      const employment = formdata.employment;
                      const profileupload = formdata.profileupload;
                      
                      if(this.isCNIC){

                        if (
                          (personalinformation > 0) &&
                          (academicinformation > 0) &&
                          (backgroundinformation > 0) &&
                          (priorhighereducation > 0) &&
                          (futurecollegeplans > 0) &&
                          (academiccareergoals > 0) &&
                          (extracurrucaullar > 0) &&
                          (employment > 0)
                          ) {
                          this.triggerPopup();
                        } else {
                          this.errorMessage = 'Please fill all forms.';
                          this.errorFlag = true;
                          this.loading = false;
                          window.scrollTo(300, 500);
                        }

                      }
                      else
                      {

                        if(profileupload > 0){

                          if (
                            (personalinformation > 0) &&
                            (academicinformation > 0) &&
                            (backgroundinformation > 0) &&
                            (priorhighereducation > 0) &&
                            (futurecollegeplans > 0) &&
                            (academiccareergoals > 0) &&
                            (extracurrucaullar > 0) &&
                            (employment > 0)
                            ) {
                            this.triggerPopup();
                          } else {
                            this.errorMessage = 'Please fill all forms.';
                            this.errorFlag = true;
                            this.loading = false;
                            window.scrollTo(300, 500);
                          }
            
                        }
                        else
                        {
            
                          this.errorMessage = 'Please upload SAR or CALSAR file first!!';
                          this.showCalSarUploadTag=true;
                          this.errorFlag = true;
                          this.loading = false;
                          window.scrollTo(300, 500);
            
                        }

                    }
                        
                });
            }
          },
          error => {
            this.submitting = false;
            this.errorFlag = true;
            const errordata = JSON.parse(error._body);
            if (errordata.success === 0) {
              this.errorMessage = errordata.message;
              this.errorFlag = true;
              this.fieldErrors = errordata.errors;
              this.loading = false;
              window.scrollTo(300, 500);
              if( errordata.calsarErrorCode == 1) {
                this.showCalSarUploadTag=true;
              }
            }
            
          },
        );
    } else {
      this.router.navigate(['/user-dashboard']);
    }
    
  }

  onFinalSubmit(){
    this.loading = true;
    const body = {
      partnerid: this.partnerid,
      lastInserted: this.lastInserted,
    };
    
    this.submitting = true;
    this.formapi.postFinalFormData$(body)
    .subscribe(
      data => {
        this.error = false;
        this.submitting = false;
        this.errorFlag = false;
        const response = JSON.parse(data._body);
        this.successMessage = response.message;
        this.loading = false;
        if (!this.canDeactivateCheck) {
          this.checkingSubmit = true;
          window.scrollTo(300, 500);
          this.finalSubmit = true;
          this.loading = true;
          setTimeout(() => {

            this.router.navigate(['/user-dashboard']);

          }, 5000);

        }
      },
      error => {
        this.submitting = false;
        this.errorFlag = true;
        const errordata = JSON.parse(error._body);
        if (errordata.success === 0) {
          this.errorMessage = errordata.message;
          this.errorFlag = true;
          this.fieldErrors = errordata.errors;
          this.loading = false;
          window.scrollTo(300, 500);
        }
      },
    );

  }

  openDialog2() {
    $('#Beforesubmitting1').modal('hide');
    $('#Beforesubmitting2').modal('show');
  }

  triggerPopup(){
    //console.log('qwdqwdq');
    $('#Beforesubmitting1').modal('show');

  }

  canDeactivate() {
    return true;
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  under18() {

    //console.log(this.adult);
    let unsereighteen  = this.digitalForm.controls.unsereighteen.value;
    //console.log(unsereighteen);
    if(unsereighteen){
      this.adult = false;
      this.digitalForm.controls.date.setValue(this.today);
    }
    else {
      this.adult = true;
      this.digitalForm.controls.date.setValue('');
      this.digitalForm.controls.parentName.setValue('');

    }
  }

  agreeTerm1(){

    let studentSignature  = this.digitalForm.controls.studentSignature.value;
    //console.log(studentSignature);
    //if(studentSignature){
      this.required = true;
    //}
  }

  agreeTerm2(){

    let parentSignature  = this.digitalForm.controls.parentSignature.value;
    //console.log(parentSignature);

  }

  createForm()  {

    this.digitalForm  = this._fb.group({
      
      studentName: ['', [Validators.required]],
      dob: [''],
      unsereighteen:[''],
      studentSignature: [''],
      date: [''],
      parentSignature: [''],
      parentName: [''],

    });

    //console.log(this.digitalForm);
    
  }

  onSubmit2() {
  
    this.loading = true;
    const digitalForm = this.digitalForm.value;
    //console.log(digitalForm);

    const body = JSON.stringify({
      studentName: this.digitalForm.controls.studentName.value,
      dob: this.today,
      unsereighteen: this.digitalForm.controls.unsereighteen.value,
      studentSignature: this.digitalForm.controls.studentSignature.value,
      date: this.digitalForm.controls.date.value,
      parentSignature: this.digitalForm.controls.parentSignature.value,
      parentName: this.digitalForm.controls.parentName.value,
      partnerid:this.partnerid
    });

    //console.log(body);

    this.formapi.postDigitalData$(body).subscribe(
      data => {
        this.error = false;
        this.submitting = false;
        this.errorFlag1 = false;
        const response = JSON.parse(data._body);
        this.successMessage1 = response.message;
        this.loading = false;
        //this.dialogRef.close(response.lastInserted);
        this.lastInserted = response.lastInserted;
        this.disableApply = true;
        this.disableSubmit = false;
        //this.dialogRef.close(this.lastInserted);
        this.onFinalSubmit();
        $('#Beforesubmitting2').modal('hide');
      },
      error => {
        this.submitting = false;
        this.errorFlag1 = true;
        const errordata = JSON.parse(error._body);
        if (errordata.success === 0) {
          this.errorMessage1 = errordata.message;
          this.errorFlag1 = true;
          this.fieldErrors = errordata.errors;
          this.loading = false;
        }
      },
    );

  }

  checkCinc(){
    const getDomainName = this.loginservice.getDomainName();
    const parts = window.location.hostname.split(getDomainName);
    //const countLength = parts.length;
    const subdomain = parts.shift();
    //console.log(subdomain);
    if(subdomain == 'cinc'){
      this.isCNIC = true;
    }
    else{
      this.isCNIC = false;
    }
  }

  changePdf(url){

    this.pdfSrc = url;
    //console.log(this.pdfSrc);
    this.openDialogPdf();
  }

  openDialogPdf() {
    const dialogRef = this.dialog.open(DialogPdfComponent, {
      height: '600px',
      data: { url: this.pdfSrc }
    });

    dialogRef.afterClosed().subscribe(result => {
      //console.log(`Dialog result: ${result}`);
    });
  }

}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/profile/partner-questions/partner-questions.component.ts